// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dt-0";
export var actionModalContentContainer = "_dt-1";
export var createTagButton = "_dt-2";
export var footerContainer = "_dt-7";
export var fullWidthDivider = "_dt-3";
export var hasCreateTagButton = "_dt-4";
export var noCreateTagButton = "_dt-5";
export var tagsContainer = "_dt-6";
export var tagsModalContentContainer = "_dt-8";